import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
export interface Relacion {
  id?: number;
  relacion: string;
  estado?: number;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RelacionService {
  private baseUrl =  `${environment.apiUrl}/api/relacion`; 
  //private baseUrl = 'http://localhost:3000/api/relacion';

  constructor(private http: HttpClient) {}

  getRelaciones(): Observable<Relacion[]> {
    return this.http
      .get<Relacion[]>(this.baseUrl)
      .pipe(catchError(this.handleError));
  }

  getRelacionById(id: number): Observable<Relacion> {
    return this.http
      .get<Relacion>(`${this.baseUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  createRelacion(relacion: Relacion): Observable<Relacion> {
    return this.http
      .post<Relacion>(this.baseUrl, relacion)
      .pipe(catchError(this.handleError));
  }

  updateRelacion(id: number, relacion: Relacion): Observable<Relacion> {
    return this.http
      .put<Relacion>(`${this.baseUrl}/${id}`, relacion)
      .pipe(catchError(this.handleError));
  }

  deleteRelacion(id: number): Observable<void> {
    return this.http
      .delete<void>(`${this.baseUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  inactivarRelacion(id: number): Observable<{ message: string }> {
    return this.http
      .put<{ message: string }>(`${this.baseUrl}/inactivar/${id}`, {})
      .pipe(catchError(this.handleError));
  }

  activarRelacion(id: number): Observable<{ message: string }> {
    return this.http
      .put<{ message: string }>(`${this.baseUrl}/activar/${id}`, {})
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.error('Error en RelacionService:', error);
    const message =
      error?.error?.message || 'Ocurrió un error en el servidor.';
    return throwError(() => new Error(message));
  }
}
